module.exports = "img/videos/2.e7e7ae.mp4";